import React, { useEffect, useRef, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, CircularProgress, Snackbar } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import grafismoPaseo from "../../../assets/imagenes/grafismo-paseo2.png";
import { getDetalleFactura } from "../../../api/ApiService";


function ZoomableImagePreview({ imagenFactura, emptyMessage, emptyDescription }) {
    const containerRef = useRef(null);
    const [zoom, setZoom] = useState(1);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [dragState, setDragState] = useState({
        isDragging: false,
        startX: 0,
        startY: 0,
        originX: 0,
        originY: 0,
    });




    useEffect(() => {
        const containerElement = containerRef.current;

        if (!containerElement) {
            return undefined;
        }

        const handleWheel = (event) => {
            if (!imagenFactura) return;

            event.preventDefault();

            const zoomStep = event.deltaY < 0 ? 0.12 : -0.12;
            setZoom((currentZoom) => {
                const nextZoom = currentZoom + zoomStep;
                const normalizedZoom = Math.min(3, Math.max(1, Number(nextZoom.toFixed(2))));

                if (normalizedZoom === 1) {
                    setOffset({ x: 0, y: 0 });
                }

                return normalizedZoom;
            });
        };

        containerElement.addEventListener("wheel", handleWheel, { passive: false });

        return () => {
            containerElement.removeEventListener("wheel", handleWheel);
        };
    }, [imagenFactura]);

    const handleMouseDown = (event) => {
        if (!imagenFactura || zoom <= 1) return;

        setDragState({
            isDragging: true,
            startX: event.clientX,
            startY: event.clientY,
            originX: offset.x,
            originY: offset.y,
        });
    };

    const handleMouseMove = (event) => {
        if (!dragState.isDragging || zoom <= 1) return;

        const deltaX = event.clientX - dragState.startX;
        const deltaY = event.clientY - dragState.startY;

        setOffset({
            x: dragState.originX + deltaX,
            y: dragState.originY + deltaY,
        });
    };

    const handleMouseUp = () => {
        setDragState((currentState) => ({
            ...currentState,
            isDragging: false,
        }));
    };

    const handleMouseLeave = () => {
        handleMouseUp();
        setZoom(1);
        setOffset({ x: 0, y: 0 });
    };

    return (
        <div
            ref={containerRef}
            className="group relative min-h-[420px] w-full overflow-hidden border-y border-gray-200 bg-[#f1f5f9] shadow-sm"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
        >
            {imagenFactura ? (
                <>
                    <img
                        src={imagenFactura}
                        alt="imagen factura"
                        draggable={false}
                        className={`h-full w-full object-contain transition-transform duration-200 ease-out select-none ${zoom > 1 ? (dragState.isDragging ? "cursor-grabbing" : "cursor-grab") : "group-hover:cursor-zoom-in"}`}
                        style={{
                            transform: `scale(${zoom}) translate(${offset.x / zoom}px, ${offset.y / zoom}px)`,
                            transformOrigin: "center center",
                        }}
                    />

                    <div className="pointer-events-none absolute inset-x-4 bottom-4 rounded-xl bg-black/55 px-3 py-2 text-xs text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                        Usa la rueda del mouse para acercar o alejar la imagen. Arrastra para moverla.
                    </div>
                </>
            ) : (
                <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                    <p className="text-base font-semibold text-gray-700">{emptyMessage}</p>
                    {emptyDescription ? (
                        <p className="mb-5 text-sm text-gray-500">{emptyDescription}</p>
                    ) : null}
                </div>
            )}
        </div>
    );
}


function CuponDetallePage() {
    const [cargando, setCargando] = useState(true);
    const [detalleFactura, setDetalleFactura] = useState(null);

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');



    const stateToken = useSelector(state => state.reducerGlobal.token);
    const navigate = useNavigate();

    const params = useParams();
    const { id } = params;

    const [searchParams] = useSearchParams();
    const mode = searchParams.get('cupon');
    // console.log("params==>", mode);







    //==========================================================obtener detalle de factura
    const handleDetalleFactura = () => {
        setCargando(true);

        getDetalleFactura(stateToken?.access_token, id)
            .then(response => {
                // console.log("getDetalleFactura", response);
                setDetalleFactura(response?.data || null);
                setCargando(false);

            })
            .catch(error => {
                console.log("error-getDetalleFactura", error);
                setCargando(false);
                setDetalleFactura(null);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    };

    useEffect(() => {
        if (id && stateToken) {
            handleDetalleFactura();
        }
    }, [id, stateToken]);





    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    const handleVolver = () => {
        navigate(-1);
    };

    const nombreCliente = detalleFactura?.cliente?.nombre_completo
        || `${detalleFactura?.cliente?.first_name || ""} ${detalleFactura?.cliente?.last_name || ""}`.trim()
        || "Sin cliente";
    const numeroCupon = detalleFactura?.nro_cupon || detalleFactura?.numero_cupon || "-";
    const numeroFactura = detalleFactura?.nro_factura || "-";







    return (
        <HeaderCustom>
            <div className="min-h-screen bg-[#b7bcc6] px-4 py-8 sm:px-6 sm:py-10">
                <div className="mx-auto w-full max-w-[420px]">
                    {cargando ? (
                        <div className="flex min-h-[520px] items-center justify-center rounded-2xl bg-white shadow-[0_20px_50px_rgba(15,23,42,0.12)]">
                            <CircularProgress color="inherit" />
                        </div>
                    ) : (
                        <div className="overflow-hidden rounded-2xl bg-white shadow-[0_20px_50px_rgba(15,23,42,0.12)]">
                            <img
                                src={grafismoPaseo}
                                alt="Grafismo Paseo"
                                className="h-[24px] w-full object-cover object-center"
                            />

                            <div className="px-4 pb-4 pt-3 text-center">
                                <h2 className="text-[38px] font-semibold leading-tight text-[#194e7a] sm:text-[40px]">
                                    {nombreCliente}
                                </h2>
                                <p className="mt-1 text-lg font-semibold text-[#194e7a]">
                                    N° Cupón {mode}
                                </p>
                                <p className="mt-1 text-base font-semibold text-[#194e7a]">
                                    N° de Factura {numeroFactura}
                                </p>
                            </div>

                            <ZoomableImagePreview
                                imagenFactura={detalleFactura?.imagen}
                                emptyMessage="No hay imagen de factura"
                                emptyDescription="No se encontró una imagen para esta factura."
                            />

                            <div className="px-4 pb-3 pt-4">
                                <button
                                    type="button"
                                    onClick={handleVolver}
                                    className="h-11 w-full rounded-full bg-[#0d4a73] text-sm font-semibold text-white transition hover:bg-[#0b4063]"
                                >
                                    Atrás
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default CuponDetallePage;